export default {
  showValue: 'Show value',
  hideValue: 'Hide value',
  showRecordedTitle: 'Show (this is recorded in the history)',
  hide: 'Hide',
  show: 'Show',
  encryptionMissing: "Pay encryption isn't set up on this server. Details can be viewed masked but not changed or revealed until an encryption key is configured.",
  compensationTitle: 'Compensation view',
  compensationMeta: 'Annual estimate',
  addRateForEstimate: 'Add a pay rate to see an estimate.',
  basePay: 'Base pay',
  superPercent: 'Super ({percent}%)',
  totalPackage: 'Total package',
  compensationFootnote: 'Showing this is recorded in the history. Estimates only; excludes allowances and benefits.',
  salaryHistory: 'Salary history',
  addSalary: 'Add salary',
  noPayRateTitle: 'No pay rate recorded',
  noPayRateMessage: "Add the employee's salary or hourly rate and when it takes effect.",
  salary: 'Salary',
  hourlyRate: 'Hourly rate',
  current: 'Current',
  effectivePayRate: 'Effective pay rate',
  effectiveFrom: 'Effective from',
  weeklyHours: 'Weekly hours',
  zeroHour: 'Zero-hour',
  comments: 'Comments',
  salaryAdded: 'Salary added.',
  addSalaryTitle: 'Add new salary',
  addSalaryDescription: 'The rate is stored encrypted and shown masked.',
  payType: 'Pay type',
  salaryPerYear: 'Salary (per year)',
  hourlyPay: 'Hourly pay',
  annualSalary: 'Annual salary',
  zeroHourCheckbox: 'This employee is a zero-hour employee',
  actualWeeklyHours: 'Actual weekly hours',
  commentsOptional: 'Comments (optional)',
  workHoursTitle: 'Work hours and pay run',
  employeeWorkHours: 'Employee work hours',
  standardDailyHours: 'Standard daily hours',
  customWorkHours: 'Custom work hours',
  normalWeeklyHours: 'Normal weekly hours',
  fteHours: 'Full-time equivalent hours',
  ordinaryWorkDay: 'Ordinary work day',
  hoursValue: '{hours} hours',
  timesheetType: 'Timesheet type',
  saved: 'Saved.',
  fteWeeklyHours: 'FTE weekly hours',
  ordinaryDayHours: 'Ordinary day (hours)',
  timesheetExceptionsOnly: 'Use timesheets for exceptions only',
  timesheetAlways: 'Timesheets required for every pay run',
  timesheetNever: 'No timesheets',
  bankingDetails: 'Banking details',
  addAccount: 'Add account',
  noBankAccountsTitle: 'No bank accounts',
  noBankAccountsMessage: 'Add the account wages are paid into.',
  shareIncomplete: 'Accounts currently receive {total}% of pay; they should add up to 100%.',
  accountRemoved: 'Account removed.',
  bsb: 'BSB',
  accountNumber: 'Account number',
  editBankAccount: 'Edit bank account',
  addBankAccount: 'Add bank account',
  keepBankOnFile: 'Leave BSB and account number blank to keep the ones on file.',
  accountName: 'Account name',
  shareOfPay: 'Share of pay (%)',
  otherAccountsShare: '{percent}% goes to other accounts.',
  taxDeclaration: 'Tax declaration',
  taxFileNumber: 'Tax file number',
  tfnNotSupplied: 'Not supplied: {reason}',
  notProvided: 'Not provided',
  australianResident: 'Australian resident for tax',
  foreignResident: 'Foreign resident for tax',
  claimsThreshold: 'Claims tax-free threshold',
  helpDebt: 'HELP / study loan debt',
  editTaxTitle: 'Edit tax declaration',
  editTaxDescription: 'The tax file number is stored encrypted. Leave it blank to keep the one on file.',
  onFile: 'On file: {value}',
  removeTfn: 'Remove the TFN on file',
  noTfnReason: 'Reason no TFN was supplied (optional)',
  noTfnReasonPlaceholder: 'e.g. Pending, Under 18',
  australianResidentCheckbox: 'Australian resident for tax purposes',
  foreignResidentCheckbox: 'Foreign resident for tax purposes',
  claimThresholdCheckbox: 'Claim the tax-free threshold from this payer',
  helpDebtCheckbox: 'Has a HELP, VSL, SFSS or TSL debt',
  superannuation: 'Superannuation',
  addFund: 'Add fund',
  noSuperTitle: 'No super fund',
  noSuperMessage: 'Add the fund super contributions are paid to.',
  fundType: 'Fund type',
  smsf: 'Self-managed super fund',
  regulated: 'Regulated',
  regulatedApra: 'Regulated (APRA) fund',
  fundName: 'Fund name',
  productName: 'Product name',
  fundAbn: 'Fund ABN',
  usi: 'USI',
  memberNumber: 'Member number',
  superDetailsTitle: 'Superannuation details',
  superDetailsDescription: 'The member number is stored encrypted. Leave it blank to keep the one on file.',
}
